import {restHelperService} from "./rest-helper.service";
import {router} from "../core/router";


export const userService = {
    login,
    logout,
    register,
    confirmRegistration,
    getProfile,
    updateProfile
};

function login(username, password) {
    let requestBody = {username: username, password: password};
    return restHelperService.createPostRequest("/rest/auth/login", requestBody, false)
        .then(res => {
            let response = restHelperService.getResponse(res);
            localStorage.setItem('token', response.token);
            localStorage.setItem("username", username);
            localStorage.setItem('user-type', response.type ? response.type.id : 1);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function logout() {
    localStorage.removeItem('token');
    router.push({path: '/login'});
}


function register(username, password, email) {
    let requestBody = {username: username, password: password, email: email};
    return restHelperService.createPostRequest("/rest/auth/register", requestBody, false)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function confirmRegistration(code) {
    let requestBody = {code: code};
    return restHelperService.createPatchRequest("/rest/auth/register", requestBody)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function getProfile() {
    return restHelperService.createGetRequest("/rest/profile")
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function updateProfile(profile) {
    return restHelperService.createPatchRequest("/rest/profile", profile)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}


